export default {
	auth_token(state) {
		return state.auth_token
	},
	me(state) {
		return state.me
	},
}
